import { useQuery } from '@tanstack/react-query';

import { Icon } from '../components/icons';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

// AppointmentSuccess: Rückmeldung nach einem vereinbarten Termin – mit dem Tagesstand und ggf. dem Tagesziel.
export function AppointmentSuccess() {
  const { project } = useProject();
  const papi = useProjectApi();
  const dash = useQuery({ queryKey: projectKeys.dashboard(project.id), queryFn: ({ signal }) => papi.dashboard(signal) });
  const t = dash.data?.telesales;
  const today = t?.appointments_created_today;
  const target = t?.targets?.appointments || 0;
  return (
    <div className="appointment-success">
      <span className="appointment-success-mark" aria-hidden="true">
        <Icon name="check" size={28} />
      </span>
      <div>
        <h2>Termin vereinbart</h2>
        <p>
          Gespeichert – der zuständige Makler sieht den Termin in seinem Kalender.
          {today ? (
            <>
              {' '}
              Heute {today === 1 ? 'Ihr erster Termin' : `schon ${today} Termine`}
              {target ? (today >= target ? ' – Tagesziel erreicht!' : ` von ${target} als Tagesziel`) : ''}.
            </>
          ) : null}
        </p>
      </div>
    </div>
  );
}
